angular.module('impactx.numberingscheme').controller("MainProcurementGroupCtrl", MainProcurementGroupCtrl);
MainProcurementGroupCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'TranslationService',
    'ToolbarService',
];

function MainProcurementGroupCtrl($scope, dataGen, $routeParams, BackService, ToastService, TranslationService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {id: $routeParams.id}, "/tender/mainprocurementgroup/get").then(function () {
        $scope.trns.required = TranslationService.get("required");
        $scope.trns.save = TranslationService.get("save");
        defineButtons();
    });

    self.saveMainProcurementGroupData = function () {
        var dataObj = {
            mpg: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/tender/mainprocurementgroup/save").then(function () {
            BackService.back();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveMainProcurementGroupData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}